/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/**
 * totaalexport.module.ts
 * 20-05-2024 - Jelmer Jellema - Spin in het Web B.V. Apeldoorn NL
 * Module voor component Totaalexportscherm
 * Selector: totaalexport
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Totaalexportscherm} from './totaalexport';
import {FileSaverModule} from 'ngx-filesaver';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

@NgModule({
  declarations: [Totaalexportscherm],
  imports: [CommonModule, FormsModule, FileSaverModule, BsDatepickerModule],
  exports: [Totaalexportscherm]
})
export class TotaalexportschermModule {
}
Totaalexportscherm.register('Totaalexportscherm');
